import { render, staticRenderFns } from "./SendCreditAmount.vue?vue&type=template&id=5c6c181e&"
import script from "./SendCreditAmount.vue?vue&type=script&lang=js&"
export * from "./SendCreditAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports